export default __webpack_public_path__ + "static/media/img-error-blue.3c2bbf94.svg";